export default __webpack_public_path__ + "static/media/sort_list.7f1bd9ce.svg";